import { render, staticRenderFns } from "./private-deal-list.vue?vue&type=template&id=1bf95084&"
import script from "./private-deal-list.vue?vue&type=script&lang=js&"
export * from "./private-deal-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports